module.exports = __webpack_public_path__ + "img/strap width.0445c6bb.png";